import React from "react";

function SvgIcMapPoi046(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M6.646 19.189c.159.134 3.688 3.006 8.593 1.206 7.974-3.587 11.414.777 11.557.963a1 1 0 01-1.592 1.212c-.1-.127-2.698-3.25-9.21-.323a11.484 11.484 0 01-3.986.732c-3.934 0-6.516-2.146-6.655-2.265a.999.999 0 111.293-1.525zM19.05 13a2.002 2.002 0 011.944 1.938h.023v1.595c-1.582.055-3.329.35-5.016 1.134a8.23 8.23 0 01-3.394.901L16.175 15H13.01l-2.297 2.703a1 1 0 11-1.414-1.414l2.039-2.401a2.02 2.02 0 01.278-.327l.007-.008A2 2 0 0113 13h6.05zm3.283-4a2 2 0 11.001 3.999A2 2 0 0122.333 9z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi046;
